import { useGetApiCompaniesCurrentGroups } from '@/api/generated/company-management-user/company-management-user'
import { Button } from '@/components/shadcn/button'
import { Checkbox } from '@/components/shadcn/checkbox'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { ChevronDown } from 'lucide-react'

interface GroupMultiSelectProps {
  selectedIds: number[]
  onChange: (ids: number[]) => void
  disabled?: boolean
}

export function GroupMultiSelect({ selectedIds, onChange, disabled }: GroupMultiSelectProps) {
  const { data } = useGetApiCompaniesCurrentGroups()
  const groups = data?.data ?? []

  const toggle = (id: number) => {
    onChange(selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id])
  }

  const label = selectedIds.length === 0
    ? 'Gruppen auswählen'
    : `${selectedIds.length} Gruppe${selectedIds.length > 1 ? 'n' : ''} ausgewählt`

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button variant="outline" className="w-full justify-between font-normal" disabled={disabled}>
          <span className="truncate">{label}</span>
          <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 max-h-60 overflow-y-auto p-1" align="start">
        {groups.length === 0 ? (
          <p className="px-2 py-4 text-sm text-center text-muted-foreground">Keine Gruppen vorhanden</p>
        ) : (
          groups.map(group => (
            <div
              key={group.id}
              className="flex items-center gap-2 px-2 py-1.5 rounded cursor-pointer hover:bg-muted/50"
              onClick={() => toggle(group.id)}
            >
              <Checkbox
                checked={selectedIds.includes(group.id)}
                onCheckedChange={() => toggle(group.id)}
                onClick={e => e.stopPropagation()}
              />
              <span className="text-sm">{group.name}</span>
            </div>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
